import { cx } from "@linaria/core";
import type { ReactNode } from "react";
import React from "react";
import { Link } from "react-router-dom";

import type {
  WPAsyncPageGroupDescriptor,
  WPPageDescriptor,
  WPPageGroupDescriptor,
} from "../../../../models/WPPageDescriptor";
import { isPageGroupDescriptor } from "../../../../utils/guards/isPageGroupDescriptor";
import { CSSRefTransition } from "../../../components/atoms/transition.css";
import { useActivePagePath } from "../../hooks/useActivePagePath";

import * as styles from "./styles/MobileLink";

export function MobileLinkItem({
  item,
  disabled,
  spin,
  onClick,
}: {
  item: WPPageDescriptor | WPPageGroupDescriptor | WPAsyncPageGroupDescriptor;
  disabled?: boolean;
  spin?: boolean;

  onClick?(evt: React.MouseEvent<HTMLAnchorElement>): void;
}): ReactNode {
  const activePagePath = useActivePagePath();

  return (
    <Link
      to={
        !isPageGroupDescriptor(item) ? item.path : (item.pages?.[0]?.path ?? "")
      }
      className={cx(styles.linkCls, disabled && "disabled")}
      aria-current={item.path === activePagePath ? "page" : undefined}
      onClick={onClick}
    >
      <span data-wp-outline>{item.title}</span>

      <CSSRefTransition
        in={!!spin}
        timeout={styles.spinnerFadeDurationMs}
        mountOnEnter
        unmountOnExit
      >
        {(ref) => <span ref={ref} className={styles.spinnerCls} />}
      </CSSRefTransition>
    </Link>
  );
}
